/**
 * Builds a Google Flights deep-link URL using the tfs protobuf parameter.
 *
 * Proto structure (from AWeirdDev/flights reverse-engineering):
 *   Airport   { field 2 = IATA code (string) }
 *   FlightData { field 2 = date, field 13 = from_airport, field 14 = to_airport, field 5 = max_stops (optional) }
 *   Info      { field 3 = legs (repeated), field 8 = passengers, field 9 = seat, field 19 = trip }
 *   Seat enum: 1=ECONOMY  Trip enum: 1=ROUND_TRIP, 2=ONE_WAY  Passenger enum: 1=ADULT
 */
export function buildGoogleFlightsUrl(origin, destination, departureDate, returnDate = null, stops = null, currency = 'EUR') {
  if (!origin || !destination || !departureDate) {
    return `https://www.google.com/travel/flights/search?hl=en&curr=${currency}`
  }

  function varint(n) {
    const b = []
    while (n > 127) { b.push((n & 0x7F) | 0x80); n >>>= 7 }
    b.push(n)
    return b
  }

  function ascii(s) {
    return Array.from(s, c => c.charCodeAt(0))
  }

  // Encode a protobuf field: tag (field_num << 3 | wire_type) + data
  // wire_type 0 = varint, wire_type 2 = length-delimited (length prefix added automatically)
  function pb(num, wireType, bytes) {
    const tag = varint((num << 3) | wireType)
    if (wireType === 2) return [...tag, ...varint(bytes.length), ...bytes]
    return [...tag, ...bytes]
  }

  const airport = code => pb(2, 2, ascii(code))

  const leg = (date, from, to, maxStops) => {
    const b = [
      ...pb(2, 2, ascii(date)),
      ...pb(13, 2, airport(from)),
      ...pb(14, 2, airport(to)),
    ]
    if (maxStops !== null) b.push(...pb(5, 0, varint(maxStops)))
    return b
  }

  const isRoundTrip = !!returnDate
  const maxStops = stops === 0 ? 0 : null

  const info = [
    ...pb(3, 2, leg(departureDate, origin, destination, maxStops)),
    ...(isRoundTrip ? pb(3, 2, leg(returnDate, destination, origin, maxStops)) : []),
    ...pb(9, 0, varint(1)),                       // seat = ECONOMY
    ...pb(8, 0, varint(1)),                       // passenger = ADULT
    ...pb(19, 0, varint(isRoundTrip ? 1 : 2)),   // trip = ROUND_TRIP or ONE_WAY
  ]

  const tfs = btoa(String.fromCharCode(...info))
  return `https://www.google.com/travel/flights/search?tfs=${encodeURIComponent(tfs)}&hl=en&curr=${currency}`
}
